export const EntityStatusBadgeVariant = {
    Draft: 'draft',
    AwaitingDropOff: 'awaitingDropOff',
    AwaitingPickUp: 'awaitingPickUp',
    Completed: 'completed',
    Cancelled: 'cancelled',
    Failed: 'failed'
} as const;

export type EntityStatusBadgeVariant = (typeof EntityStatusBadgeVariant)[keyof typeof EntityStatusBadgeVariant];
